import { Feature, hasUserAtLeastOnePermission } from "@flixbus-phx/marketplace-common";

export default () => {
  return hasUserAtLeastOnePermission([
    Feature.EDIT_CAPACITY_MANAGER_CAPACITY,
    Feature.EDIT_CAPACITY_MANAGER_STOP_OR_RESTART_SALES,
    Feature.EDIT_CAPACITY_MANAGER_CANCEL_RIDE,
  ]);
};
